import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import { attempt } from 'lodash-es';
import { getModifiedProps } from 'react-jsx-highcharts';
import NavigatorXAxis from './NavigatorXAxis';

var Navigator =
/*#__PURE__*/
function (_Component) {
  _inherits(Navigator, _Component);

  function Navigator(props) {
    var _this;

    _classCallCheck(this, Navigator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Navigator).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateNavigator", function (config) {
      var chart = _this.props.getChart();

      chart.update({
        navigator: config
      }, true);
    });

    _this.state = {
      rendered: false
    };
    return _this;
  }

  _createClass(Navigator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          children = _this$props.children,
          getHighcharts = _this$props.getHighcharts,
          getChart = _this$props.getChart,
          rest = _objectWithoutProperties(_this$props, ["children", "getHighcharts", "getChart"]); // Workaround from http://jsfiddle.net/x40me94t/2/


      var Highcharts = getHighcharts();
      var chartObj = getChart().object;
      chartObj.options.navigator.enabled = true;
      Highcharts.fireEvent(chartObj, 'beforeRender');
      this.updateNavigator(rest);
      this.setState({
        rendered: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var modifiedProps = getModifiedProps(prevProps, this.props);

      if (modifiedProps !== false) {
        this.updateNavigator(modifiedProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      attempt(this.updateNavigator, {
        enabled: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      if (!children || !this.state.rendered) return null;
      var navChildren = Children.map(children, function (child) {
        if (isValidElement(child) === false) return child;
        return cloneElement(child, _this2.state);
      });
      return React.createElement(NavigatorXAxis, null, navChildren);
    }
  }]);

  return Navigator;
}(Component);

_defineProperty(Navigator, "defaultProps", {
  enabled: true
});

export default Navigator;